import type { TypePolicies, TypePolicy } from '@apollo/client';

import entityKeyFields from 'bundles/page/lib/network/entityKeyFields';

import NaptimeLinkNamespaces from './NaptimeLinkNamespaces.json';
import AssemblerCacheTypes from './__generated__/cache-types.assembler.json';
import GatewayCacheTypes from './__generated__/cache-types.gateway.json';

type KeyFields = TypePolicy['keyFields'];

const NamespaceTypePolicy: TypePolicy = { keyFields: [], merge: true };
const StructTypePolicy: TypePolicy = { keyFields: false, merge: true };
const keyFieldTypePolicy: (keyFields: KeyFields) => TypePolicy = (keyFields) => ({ keyFields, merge: true });

export type EntityKeyFieldsMap = Record<string, KeyFields>;

export const typePolicies: TypePolicies = Object.fromEntries([
  ...AssemblerCacheTypes.namespaces.map((name) => [name, NamespaceTypePolicy]),
  ...AssemblerCacheTypes.structs.map((name) => [name, StructTypePolicy]),
  ...GatewayCacheTypes.namespaces.map((name) => [name, NamespaceTypePolicy]),
  ...GatewayCacheTypes.structs.map((name) => [name, StructTypePolicy]),
  /*
   * The generator in scripts/getApolloCacheTypeNames.js omits ID-bearing structs, so Task and RawEntity need manual
   * policies. Their IDs are scoped, not globally unique; task IDs are unique only within one configuration.
   * Explainer has no ID, and its entry can be removed after cache-types.gateway.json is regenerated.
   */
  ['Recommendation_Task', StructTypePolicy],
  ['Recommendation_RawEntity', StructTypePolicy],
  ['Recommendation_Explainer', StructTypePolicy],
  ...NaptimeLinkNamespaces.map((name) => [`Naptime${name}Resource`, NamespaceTypePolicy]),
  ...Object.entries(entityKeyFields).map(([name, keyFields]) => [name, keyFieldTypePolicy(keyFields)]),
]);
